<template>
  <svg class="svg" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="iconos" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="facebook" transform="translate(2.000000, 2.000000)" fill="currentColor" fill-rule="nonzero">
        <path d="M22.75,0 L3.25,0 C1.457625,0 0,1.457625 0,3.25 L0,22.75 C0,24.542375 1.457625,26 3.25,26 L13,26 L13,17.0625 L9.75,17.0625 L9.75,13 L13,13 L13,9.75 C13,7.057375 15.182375,4.875 17.875,4.875 L21.125,4.875 L21.125,8.9375 L19.5,8.9375 C18.603,8.9375 17.875,8.853 17.875,9.75 L17.875,13 L21.9375,13 L20.3125,17.0625 L17.875,17.0625 L17.875,26 L22.75,26 C24.542375,26 26,24.542375 26,22.75 L26,3.25 C26,1.457625 24.542375,0 22.75,0 Z" id="Shape"></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FacebookIcon'
}
</script>

<style scoped>
.svg {
  fill: currentColor;
  width: 25px;
}
path {
  stroke: currentColor
}
</style>